module.exports = __webpack_public_path__ + "static/media/bsl_logo.bf57a519.png";